import { useState } from "react";
import { MessageSquare } from "lucide-react";
import FeedbackModal from "./FeedbackModal";

type MessageFeedbackActionProps = {
  messageId?: string | null;
  className?: string;
};

function isPersistedMessageId(messageId?: string | null): messageId is string {
  return Boolean(
    messageId &&
      !messageId.startsWith("temp-") &&
      !messageId.startsWith("ai-"),
  );
}

export default function MessageFeedbackAction({
  messageId,
  className = "flex items-center gap-1 hover:text-gray-600 disabled:cursor-default disabled:opacity-70",
}: MessageFeedbackActionProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);

  if (!isPersistedMessageId(messageId)) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        disabled={hasSubmitted}
        className={className}
      >
        <MessageSquare size={11} />
        <span>{hasSubmitted ? "Feedback sent" : "Feedback"}</span>
      </button>

      {isOpen && (
        <FeedbackModal
          messageId={messageId}
          onClose={() => setIsOpen(false)}
          onSubmitted={() => setHasSubmitted(true)}
        />
      )}
    </>
  );
}
